<template>
  <DialogWrapper
    class="save-search-dialog"
    close-on-cancel
    destroyOnClose
    :show.sync="show"
    :loading="loading"
    :title="titleI18nKey ? $t(titleI18nKey) : $t(`${i18nPrefix}.label.saveSearch`)"
    @save="handleSaveClick"
  >
    <div class="message">{{ saveTipI18nKey ? $t(saveTipI18nKey) : $t(`${i18nPrefix}.message.saveOrUpdate`) }}</div>
    <div class="form-container">
      <div class="form-item">
        <el-radio v-model="saveSearchDialog.isEditMode" :label="false" @input="handleRadioChange">{{ saveContentI18nKey ? $t(saveContentI18nKey) : $t(`${i18nPrefix}.label.saveNewSearch`) }}</el-radio>
        <transition name="slide">
          <el-form v-if="!saveSearchDialog.isEditMode" ref="saveSearchForm" class="save-search-form" :model="saveSearchDialog">
            <el-form-item prop="templateName" :label="$t(`${i18nPrefix}.label.name`)" :rules="[{ required: true, message: $t('common.message.requiredFormField'), trigger: 'blur' }, {validator: validateTemplateName, message: $t('common.message.nameHasExist'), trigger: 'blur'}]">
              <el-input v-model="saveSearchDialog.templateName"></el-input>
            </el-form-item>
          </el-form>
        </transition>
      </div>
      <div class="form-item" :class="!saveSearchDialog.isEditMode && 'change-margin'">
        <el-radio v-model="saveSearchDialog.isEditMode" :label="true" @input="handleRadioChange">{{ updateContentI18nKey ? $t(updateContentI18nKey) : $t(`${i18nPrefix}.label.updateSearch`) }}</el-radio>
        <transition name="slide">
          <el-form v-if="saveSearchDialog.isEditMode" ref="saveSearchForm" class="save-search-form" :model="saveSearchDialog">
            <el-form-item prop="templateName" :label="$t(`${i18nPrefix}.label.name`)" :rules="[{ required: true, message: $t('common.message.requiredFormField'), trigger: 'blur' }]">
              <el-select v-model="saveSearchDialog.templateName">
                <el-option
                  v-for="(item, index) in searchTemplateList"
                  :key="index"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </transition>
      </div>
    </div>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {
    titleI18nKey: {
      type: String,
      required: false
    },
    saveTipI18nKey: {
      type: String,
      required: false
    },
    saveContentI18nKey: {
      type: String,
      required: false
    },
    updateContentI18nKey: {
      type: String,
      required: false
    },
    searchTemplateList: {
      type: Array,
      required: true
    },
    searchTemplate: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      loading: false,
      show: false,
      saveSearchDialog: {
        templateName: null,
        isEditMode: false
      }
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    openDialog () {
      this.show = true
    },
    closeDialog () {
      this.show = false
    },
    clearForm () {
      if (this.searchTemplate?.name) {
        this.saveSearchDialog.templateName = this.searchTemplate.name
        this.saveSearchDialog.isEditMode = Boolean(this.searchTemplate?.name)
      } else {
        this.saveSearchDialog.templateName = null
        this.saveSearchDialog.isEditMode = false
      }
      this.$nextTick(() => {
        this.$refs.saveSearchForm.clearValidate()
      })
    },
    validate () {
      let result = false
      this.$refs.saveSearchForm.validate((isSuccess, failObject) => {
        result = isSuccess
      })
      return result
    },
    handleSaveClick () {
      const isValid = this.validate()
      if (!isValid) {
        return
      }
      this.$emit('save', this.saveSearchDialog, (close) => {
        if (close) {
          this.closeDialog()
        }
      })
    },
    validateTemplateName (rule, value, callback) {
      if (value) {
        const found = _.findIndex(this.searchTemplateList, { name: value }) > -1
        if (found) {
          callback(new Error('Name has existed!'))
          return
        }
      }
      callback()
    },
    handleRadioChange () {
      this.saveSearchDialog.templateName = null
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.save-search-dialog {
  font-size: 18px;

  .form-container {
    margin-top: 14px;

    .form-item {
      &:last-child {
        margin-top: 10px;

        &.change-margin {
          margin-top: 0;
          margin-bottom: 10px;
        }
      }

      .save-search-form {
        overflow: hidden;

        ::v-deep .el-form-item {
          padding-left: 24px;

          .el-radio__label {
            font-size: 16px;
          }

          .el-form-item__label {
            line-height: 26px;
            font-size: 16px;
          }
        }

        &.slide-enter-active {
          height: 0;
          transition: all .5s ease;
        }

        &.slide-leave-active {
          height: 88px;
          transition: all .5s ease;
        }

        &.slide-enter-to {
          height: 88px;
        }

        &.slide-leave-to {
          height: 0;
        }
      }
    }
  }
}
</style>
